import type { Route } from "router";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

export interface PageBreadcrumbData {
  title: string;
  items: BreadcrumbItem[];
}

const APP_NAME = "TTC";

const getRouteLabel = (route: Route) =>
  route.breadcrumb || route.title || route.name || "";

export const getPageBreadcrumb = (
  pathname: string,
  routes: Route[],
): PageBreadcrumbData | null => {
  for (const route of routes) {
    if (!route.path || route.hidden) continue;

    if (route.children?.length) {
      for (const child of route.children) {
        if (!child.path) continue;

        const fullPath = `${route.path}/${child.path}`;
        if (pathname === fullPath) {
          const parentLabel = getRouteLabel(route);
          const childLabel = getRouteLabel(child);

          return {
            title: childLabel,
            items: [
              { label: APP_NAME, path: "/" },
              { label: parentLabel, path: route.path },
              { label: childLabel },
            ],
          };
        }
      }
    }

    if (pathname === route.path) {
      const label = getRouteLabel(route);

      return {
        title: label,
        items: [{ label: APP_NAME, path: "/" }, { label }],
      };
    }
  }

  return null;
};
